@if (visible()) {
  <section
    class="mb-xl rounded-lg border border-primary-200 bg-primary-50 p-xl"
    aria-labelledby="getting-started-title">
    <div class="flex items-start justify-between gap-md">
      <div>
        <h2
          id="getting-started-title"
          class="m-0 text-lg font-semibold text-neutral-900">
          {{ 'getting_started_title' | transloco }}
        </h2>
        <p class="mt-x-sm mb-0 text-sm text-neutral-600">
          {{ 'getting_started_description' | transloco }}
        </p>
      </div>
      <button
        type="button"
        id="getting-started-dismiss"
        class="text-sm text-neutral-600 bg-transparent"
        (click)="dismiss()">
        {{ 'getting_started_dismiss' | transloco }}
      </button>
    </div>
    <ol class="mt-lg mb-0 list-none p-0 flex flex-col gap-sm">
      @for (step of checklist()!.steps; track step.key) {
        <li class="flex items-center gap-md">
          <span
            class="size-5 rounded-full border"
            [class.bg-success-500]="step.done"
            [class.border-success-500]="step.done"
            [class.border-neutral-300]="!step.done"
            [attr.aria-label]="
              (step.done ? 'getting_started_done' : 'getting_started_todo')
                | transloco
            "></span>
          @if (step.done) {
            <span class="text-sm text-neutral-500 line-through">
              {{ 'getting_started_step_' + step.key | transloco }}
            </span>
          } @else {
            <a
              class="text-sm font-medium text-primary-700"
              [routerLink]="links[step.key]">
              {{ 'getting_started_step_' + step.key | transloco }}
            </a>
          }
        </li>
      }
    </ol>
  </section>
}
